export const backUrl =
  process.env.NODE_ENV === "production" && navigator.userAgent !== "ReactSnap"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5001/api";

export const backUrlAgent = "http://localhost:5000/api";

//export const preMyceliumURL = "http://localhost:8080";
export const preMyceliumURL = "https://us-central1-mantis-387623.cloudfunctions.net/pre-micelio";

export const mantisApiKey = "AIzaSyBiYmnowyU12ae67QsWIVMuNq6vXk9gPJc";
